
(function () {
  'use strict';
  try {
    var btn = document.querySelector('.nav-menu');
    var panel = document.getElementById('navPanel');
    if (!btn || !panel) return;
    var closeBtn = panel.querySelector('.nav-panel-close');
    var links = panel.querySelectorAll('.nav-panel-links a');
    var root = document.documentElement;
    var open = false;
    function setOpen(next) {
      if (next === open) return;
      open = next;
      panel.setAttribute('data-open', String(open));
      btn.setAttribute('aria-expanded', String(open));
      if (open) {
        panel.removeAttribute('inert');
        panel.removeAttribute('aria-hidden');
      } else {
        panel.setAttribute('inert', '');
        panel.setAttribute('aria-hidden', 'true');
      }
      root.classList.toggle('menu-open', open);
      if (open) {
        if (closeBtn) closeBtn.focus();
      } else {
        btn.focus();
      }
    }
    setOpen(false);
    panel.setAttribute('inert', '');
    panel.setAttribute('aria-hidden', 'true');
    btn.setAttribute('aria-expanded', 'false');
    btn.addEventListener('click', function () { setOpen(!open); });
    if (closeBtn) closeBtn.addEventListener('click', function () { setOpen(false); });
    panel.addEventListener('click', function (e) {
      if (e.target === panel) setOpen(false);
    });
    Array.prototype.forEach.call(links, function (a) {
      a.addEventListener('click', function () { setOpen(false); });
    });
    document.addEventListener('keydown', function (e) {
      if (!open) return;
      if (e.key === 'Escape' || e.key === 'Esc') {
        e.preventDefault();
        setOpen(false);
      }
    });
    var mq = window.matchMedia('(min-width: 761px)');
    var onChange = function (e) { if (e.matches) setOpen(false); };
    if (mq.addEventListener) mq.addEventListener('change', onChange);
    else if (mq.addListener) mq.addListener(onChange);
  } catch (e) {}
})();